let EntityUtil = {
  canEdit (ownerId, entity) {
    let userId = localStorage.getItem('userid')
    if (this.isThisContentIsMine(ownerId, entity, userId)) {
      return true
    }
    if (this.isCanWriteOtherUsersContentAndNotShared(entity, userId)) {
      return true
    }
    let perm = this.getPermissionFromACE(entity, userId, false)
    if ((perm === 'share') || (perm === 'write')) {
      return true
    }
    return false
  },
  isThisContentIsMine (ownerId, entity, userId) {
    if (ownerId === userId) {
      return true
    }
    return false
  },
  isCanWriteOtherUsersContentAndNotShared (entity, userId) {
    let userObj = JSON.parse(localStorage.getItem('userobj'))
    if (userObj) {
      let permission = userObj.permission
      if (permission && permission.systemPermission.otherUsersContentPermission.write) {
        return this.isNotSharedWithMe(entity, userId)
      }
    }
    return false
  },
  isNotSharedWithMe (entity, userId) {
    let acelist = this.getACEList(entity)
    let isSharedWithMe = this.isThisACEListSharedWithMe(acelist, userId)
    if (!isSharedWithMe) {
      return true
    }
    return false
  },
  getACEList (entity) {
    let aceList = entity.acelist
    if (aceList !== undefined) {
      if (aceList !== null) {
        if (aceList.length > 0) {
          return aceList
        }
      }
    }
    return entity.effectiveAceList
  },
  isThisACEListSharedWithMe (aceList, userId) {
    if (aceList === undefined) {
      return false
    }
    let length = aceList.length
    for (let i = 0; i < length; i++) {
      let ace = aceList[i]
      if (ace.principal != null) {
        let foundThisUser = false
        let _class = ace.principal._class
        if (_class === 'com.pragyasystems.knowledgeHub.api.security.User') {
          let entityId = ace.principal.uuid
          foundThisUser = (userId === entityId)
        } else {
          let UUIDList = ace.principal.userUuidList
          foundThisUser = this.containsObject(userId, UUIDList)
        }
        if (foundThisUser) {
          let sharedPermission = ace.permission.sharedPermission
          if (sharedPermission) {
            return true
          }
        }
      }
    }
    return false
  },
  getPermissionFromACE (entity, userId, isOwner) {
    if (!entity) {
      console.log('getPermissionFromACE, Serious issue: no entity passed')
      return undefined
    }
    let aggregatedPermissions = {
      read: false,
      write: false,
      share: false
    }
    let acelist = this.getACEList(entity)
    if (acelist == null) {
      return undefined
    }
    let length = acelist.length
    for (let i = 0; i < length; i++) {
      let ace = acelist[i]
      if (ace.principal != null) {
        let foundThisUser = false
        let _class = ace.principal._class
        if (_class === 'com.pragyasystems.knowledgeHub.api.security.User') {
          let entityUuid = ace.principal.uuid
          foundThisUser = (userId === entityUuid)
        } else {
          let UUIDList = ace.principal.userUuidList
          foundThisUser = this.containsObject(userId, UUIDList)
        }
        if (foundThisUser) {
          let permission = ace.permission
          let sharedPermission = permission.sharedPermission
          let setUpSharedPermission = true
          let myPermission
          if (sharedPermission) {
            myPermission = sharedPermission
          } else {
            let typeOfEntity = this.typeOfEntity(entity)
            myPermission = this.getPermissionForEntityType(permission, typeOfEntity)
            if (!isOwner) {
              setUpSharedPermission = false
            }
          }
          let sharePermisson = setUpSharedPermission ? myPermission.share : false
          let writePermisson = isOwner || myPermission.write
          let readPermisson = isOwner || myPermission.read
          if (myPermission) {
            aggregatedPermissions.share |= sharePermisson
            aggregatedPermissions.write |= writePermisson
            aggregatedPermissions.read |= readPermisson
          }
        }
      }
    }
    if (aggregatedPermissions.share) {
      return 'share'
    }
    if (aggregatedPermissions.write) {
      return 'write'
    }
    if (aggregatedPermissions.read) {
      return 'read'
    }
    return undefined
  },
  containsObject (targetObject, myList) {
    if (myList !== undefined && myList !== null) {
      let len = myList.length
      for (let i = 0; i <= len; i++) {
        let myObj = myList[i]
        if (myObj === targetObject) {
          return true
        }
      }
    }
    return false
  },
  typeOfEntity (entity) {
    if (entity.entityType !== undefined) {
      if (entity.entityType === 'deliverycontext') {
        return 'COURSE'
      }
      return entity.entityType
    }
    let objectType = entity.objectType
    if (objectType === undefined) {
      objectType = entity.category
    }
    if (objectType === 'LearningContent') {
      return 'ASSET'
    }
    if (objectType === 'LearningTopic') {
      return 'TOPIC'
    }
    if (objectType === 'DeliveryContext') {
      return 'COURSE'
    }
    if (objectType === 'Stream') {
      return 'STREAM'
    }
    if (objectType === 'Job') {
      return 'JOB'
    }
    if (objectType === 'Person') {
      return 'PERSON'
    }
    if (objectType === 'Catalog') {
      return 'CATALOG'
    }
    let type = entity.type
    if (type !== undefined) {
      if (type === 'REMOTE' || type === 'SCORM' || type === 'LOCAL') {
        return 'ASSET'
      }
      return type
    }
  },
  getPermissionForEntityType (permission, entityType) {
    if (permission) {
      if (entityType === 'ASSET') {
        return permission.assetPermission
      }
      if (entityType === 'TOPIC') {
        return permission.topicPermission
      }
      if (entityType === 'COURSE') {
        return permission.coursePermission
      }
      if (entityType === 'STREAM') {
        return permission.streamPermission
      }
      if (entityType === 'JOB') {
        return permission.jobPermission
      }
      if (entityType === 'PERSON') {
        return permission.personPermission
      }
      if (entityType === 'CATALOG') {
        return permission.catalogPermission
      }
    }
    return {'read': false, 'write': false, 'share': false}
  }
}

export { EntityUtil }



// WEBPACK FOOTER //
// ./src/entityUtils.js